import { client,Client } from "./client";

interface SUCCESS<T> {
    status          :true,
    data            :T,
}

interface FAILURE {
    status          : false,
    error          ?: string,
}

export type RESPONSE<T> = SUCCESS<T> | FAILURE

const is_object = ($_:unknown):$_ is {[key:string]:unknown} => $_ !== null && (typeof $_ === 'object' || typeof $_ === 'function')
const IS_RESPONSE = <T>($_:unknown):$_ is RESPONSE<T> => is_object($_) && ('status' in $_) && typeof $_['status'] === 'boolean';
const IS_ERROR = <T>($_:RESPONSE<T>):$_ is FAILURE    => !$_.status;
type RequestFunction<T> = (client:Client) => Promise<RESPONSE<T>>

export const Request = async <T>(fn:RequestFunction<T>) => {
    const $_:unknown = await fn(client);
    if( !IS_RESPONSE<T>($_) ) throw new TypeError('APIの返値が正しくありません');
    if( IS_ERROR($_) ) throw $_.error;
    return $_.data;
}
